export const LANGUAGE_CODES = {
  enUS: 'en-US',
  enGB: 'en-GB',
  es: 'es',
  de: 'de',
} as const;
